module.exports = "<div class=\"logo\">\n  <span class=\"icon-benchmark\"></span>\n</div>\n<a class=\"icon-survey\"\n   routerLink=\"/l/location-list\"\n   routerLinkActive=\"active\">Surveys</a>\n<a class=\"icon-save\"\n   routerLink=\"/l/saved-surveys\"\n   routerLinkActive=\"active\">\n  <span>Saved</span>\n</a>\n<div class=\"lower-nav\">\n  <a class=\"icon-settings\"\n     routerLink=\"/l/settings\"\n     routerLinkActive=\"active\">Settings</a>\n  <a id=\"intercom\"\n     class=\"icon-intercom\">Live Support</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/nav/nav.component.html
// module id = 277
// module chunks = 1